// extracted by mini-css-extract-plugin
export default {"card":"BrokerCard_card__1f2eg","icon_wrapper":"BrokerCard_icon_wrapper__wH2PX","title":"BrokerCard_title__QYksg","upcomming":"BrokerCard_upcomming__5jOC5"};